import {
  combineReducers,
  legacy_createStore as createStore,
  applyMiddleware,
} from 'redux';
import thunk from 'redux-thunk';
import reducers from '../store';

export default function configureStore() {
  return createStore(
    combineReducers({
      ...reducers,
    }),
    applyMiddleware(thunk)
  );
}
